var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _path7, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _path8, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _path9, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _path10, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _path11, _rect122, _rect123, _rect124, _rect125, _path12, _path13, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _path14, _path15, _path16, _rect154, _rect155, _rect156, _path17, _rect157, _rect158, _path18, _path19, _path20, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 51,
    viewBox: "0 0 456 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.813 38.7299L119.613 36.3121H121.782V41.2188H106.884L106.813 38.7299ZM106.849 41.5743C104.858 41.5743 103.056 41.278 101.444 40.6854C99.8563 40.0928 98.4815 39.2395 97.32 38.1254C96.1585 36.9876 95.2696 35.5891 94.6533 33.9299C94.0371 32.2706 93.7289 30.3743 93.7289 28.241C93.7289 26.1076 94.0371 24.2232 94.6533 22.5876C95.2696 20.9284 96.1585 19.5417 97.32 18.4276C98.4815 17.2899 99.8563 16.4247 101.444 15.8321C103.056 15.2395 104.858 14.9432 106.849 14.9432C108.816 14.9432 110.606 15.2395 112.218 15.8321C113.83 16.4247 115.216 17.2899 116.378 18.4276C117.539 19.5654 118.428 20.9521 119.044 22.5876C119.661 24.2232 119.969 26.1076 119.969 28.241C119.969 30.3743 119.661 32.2706 119.044 33.9299C118.428 35.5891 117.539 36.9876 116.378 38.1254C115.216 39.2395 113.83 40.0928 112.218 40.6854C110.606 41.278 108.816 41.5743 106.849 41.5743ZM106.849 36.1343C108.176 36.1343 109.338 35.8499 110.333 35.281C111.329 34.7121 112.087 33.8469 112.609 32.6854C113.154 31.5239 113.427 30.0425 113.427 28.241C113.427 26.8899 113.273 25.7284 112.964 24.7565C112.656 23.761 112.206 22.9432 111.613 22.3032C111.044 21.6632 110.357 21.1891 109.551 20.881C108.745 20.5491 107.844 20.3832 106.849 20.3832C105.521 20.3832 104.36 20.6676 103.364 21.2365C102.393 21.7817 101.634 22.635 101.089 23.7965C100.544 24.958 100.271 26.4395 100.271 28.241C100.271 29.5921 100.425 30.7773 100.733 31.7965C101.065 32.7921 101.516 33.6099 102.084 34.2499C102.653 34.8899 103.341 35.3639 104.147 35.6721C104.953 35.9802 105.853 36.1343 106.849 36.1343ZM130.805 41.5743C129.312 41.5743 128.056 41.2899 127.036 40.721C126.017 40.1284 125.247 39.275 124.725 38.161C124.228 37.0232 123.979 35.6602 123.979 34.0721V22.0187H129.988V32.4365C129.988 33.361 130.094 34.1432 130.308 34.7832C130.545 35.3995 130.9 35.8736 131.374 36.2054C131.848 36.5373 132.465 36.7032 133.223 36.7032C134.005 36.7032 134.669 36.5136 135.214 36.1343C135.759 35.755 136.174 35.2691 136.459 34.6765C136.743 34.0839 136.885 33.4439 136.885 32.7565V22.0187H142.894V41.2188H137.099L136.885 37.8765H136.601C136.15 39.0854 135.404 40.0099 134.361 40.6499C133.318 41.2662 132.133 41.5743 130.805 41.5743ZM153.513 41.5743C152.351 41.5743 151.285 41.3491 150.313 40.8987C149.365 40.4484 148.547 39.7965 147.859 38.9432C147.172 38.0899 146.639 37.0469 146.259 35.8143C145.904 34.5817 145.726 33.1832 145.726 31.6187C145.726 29.5091 146.046 27.7195 146.686 26.2499C147.35 24.7565 148.262 23.6187 149.424 22.8365C150.585 22.0543 151.948 21.6632 153.513 21.6632C154.414 21.6632 155.243 21.8054 156.002 22.0899C156.784 22.3506 157.448 22.7417 157.993 23.2632C158.538 23.761 158.941 24.3536 159.202 25.041H159.522L159.735 22.0187H165.459V41.2188H159.735L159.522 38.1965H159.202C158.822 39.2158 158.111 40.0336 157.068 40.6499C156.049 41.2662 154.864 41.5743 153.513 41.5743ZM155.717 36.7387C156.571 36.7387 157.27 36.561 157.815 36.2054C158.36 35.8262 158.763 35.3165 159.024 34.6765C159.308 34.0365 159.451 33.3136 159.451 32.5076V30.7299C159.451 29.8765 159.297 29.1299 158.988 28.4899C158.704 27.8499 158.289 27.3639 157.744 27.0321C157.222 26.6765 156.594 26.4987 155.859 26.4987C154.935 26.4987 154.177 26.7121 153.584 27.1387C152.991 27.5417 152.553 28.1343 152.268 28.9165C151.984 29.675 151.842 30.5758 151.842 31.6187C151.842 32.638 151.972 33.5387 152.233 34.321C152.517 35.0795 152.944 35.6721 153.513 36.0987C154.082 36.5254 154.817 36.7387 155.717 36.7387ZM169.212 41.2188V22.0187H175.007L175.221 25.3254H175.505C176.003 24.0928 176.773 23.1802 177.816 22.5876C178.883 21.9713 180.068 21.6632 181.372 21.6632C182.32 21.6632 183.197 21.8054 184.003 22.0899C184.832 22.3743 185.555 22.8365 186.172 23.4765C186.788 24.0928 187.262 24.9106 187.594 25.9299C187.949 26.9254 188.127 28.1343 188.127 29.5565V41.2188H182.118V30.8721C182.118 29.9002 182 29.0943 181.763 28.4543C181.549 27.8143 181.206 27.3402 180.732 27.0321C180.281 26.7002 179.677 26.5343 178.918 26.5343C178.112 26.5343 177.437 26.7239 176.892 27.1032C176.347 27.4825 175.932 27.9684 175.647 28.561C175.363 29.1536 175.221 29.7817 175.221 30.4454V41.2188H169.212ZM198.464 41.2188C196.71 41.2188 195.418 40.8158 194.588 40.0099C193.782 39.1802 193.379 37.8765 193.379 36.0987V26.8543H190.073V22.0187H193.379V16.9343L199.388 16.401V22.0187H203.051V26.8543H199.388V34.961C199.388 35.5062 199.519 35.8854 199.779 36.0987C200.064 36.2884 200.431 36.3832 200.882 36.3832H203.086V41.2188H198.464ZM212.543 41.5743C211.049 41.5743 209.793 41.2899 208.774 40.721C207.755 40.1284 206.984 39.275 206.463 38.161C205.965 37.0232 205.716 35.6602 205.716 34.0721V22.0187H211.725V32.4365C211.725 33.361 211.832 34.1432 212.045 34.7832C212.282 35.3995 212.638 35.8736 213.112 36.2054C213.586 36.5373 214.202 36.7032 214.961 36.7032C215.743 36.7032 216.407 36.5136 216.952 36.1343C217.497 35.755 217.912 35.2691 218.196 34.6765C218.481 34.0839 218.623 33.4439 218.623 32.7565V22.0187H224.632V41.2188H218.836L218.623 37.8765H218.338C217.888 39.0854 217.141 40.0099 216.098 40.6499C215.055 41.2662 213.87 41.5743 212.543 41.5743ZM228.388 41.2188V22.0187H234.219L234.397 25.3254H234.681C235.132 24.0928 235.867 23.1802 236.886 22.5876C237.929 21.9713 239.067 21.6632 240.299 21.6632C241.603 21.6632 242.8 21.9713 243.89 22.5876C244.981 23.2039 245.787 24.2825 246.308 25.8232H246.593C247.019 24.4247 247.79 23.3817 248.904 22.6943C250.041 22.0069 251.321 21.6632 252.744 21.6632C253.976 21.6632 255.078 21.9239 256.05 22.4454C257.022 22.9432 257.793 23.7728 258.361 24.9343C258.954 26.0958 259.25 27.6365 259.25 29.5565V41.2188H253.241V30.8721C253.241 29.9002 253.135 29.0943 252.921 28.4543C252.732 27.8143 252.412 27.3402 251.961 27.0321C251.535 26.7002 250.966 26.5343 250.255 26.5343C249.52 26.5343 248.892 26.7239 248.37 27.1032C247.873 27.4825 247.493 27.9684 247.233 28.561C246.972 29.1536 246.841 29.7817 246.841 30.4454V41.2188H240.797V30.8721C240.797 29.9002 240.702 29.0943 240.513 28.4543C240.323 27.8143 240.003 27.3402 239.553 27.0321C239.126 26.7002 238.557 26.5343 237.846 26.5343C237.111 26.5343 236.483 26.7239 235.961 27.1032C235.464 27.4825 235.073 27.9684 234.788 28.561C234.527 29.1536 234.397 29.7817 234.397 30.4454V41.2188H228.388Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.899 41.2188V15.2987H274.241C276.848 15.2987 279.041 15.8439 280.819 16.9343C282.62 18.0247 283.983 19.5417 284.908 21.4854C285.832 23.4291 286.294 25.6928 286.294 28.2765C286.294 30.1965 286.033 31.9506 285.512 33.5387C284.991 35.1269 284.208 36.5017 283.165 37.6632C282.146 38.801 280.89 39.678 279.396 40.2943C277.927 40.9106 276.208 41.2188 274.241 41.2188H262.899ZM269.263 35.8143H273.174C274.099 35.8143 274.952 35.7076 275.734 35.4943C276.54 35.2573 277.239 34.8543 277.832 34.2854C278.448 33.7165 278.922 32.9343 279.254 31.9387C279.61 30.9432 279.788 29.675 279.788 28.1343C279.788 26.1906 279.491 24.6854 278.899 23.6187C278.33 22.5284 277.548 21.7699 276.552 21.3432C275.58 20.9165 274.454 20.7032 273.174 20.7032H269.263V35.8143ZM296.588 41.5743C295.426 41.5743 294.36 41.3491 293.388 40.8987C292.44 40.4484 291.622 39.7965 290.934 38.9432C290.247 38.0899 289.714 37.0469 289.334 35.8143C288.979 34.5817 288.801 33.1832 288.801 31.6187C288.801 29.5091 289.121 27.7195 289.761 26.2499C290.425 24.7565 291.337 23.6187 292.499 22.8365C293.66 22.0543 295.023 21.6632 296.588 21.6632C297.489 21.6632 298.318 21.8054 299.077 22.0899C299.859 22.3506 300.523 22.7417 301.068 23.2632C301.613 23.761 302.016 24.3536 302.277 25.041H302.597L302.81 22.0187H308.534V41.2188H302.81L302.597 38.1965H302.277C301.897 39.2158 301.186 40.0336 300.143 40.6499C299.124 41.2662 297.939 41.5743 296.588 41.5743ZM298.792 36.7387C299.646 36.7387 300.345 36.561 300.89 36.2054C301.435 35.8262 301.838 35.3165 302.099 34.6765C302.383 34.0365 302.526 33.3136 302.526 32.5076V30.7299C302.526 29.8765 302.372 29.1299 302.063 28.4899C301.779 27.8499 301.364 27.3639 300.819 27.0321C300.297 26.6765 299.669 26.4987 298.934 26.4987C298.01 26.4987 297.252 26.7121 296.659 27.1387C296.066 27.5417 295.628 28.1343 295.343 28.9165C295.059 29.675 294.917 30.5758 294.917 31.6187C294.917 32.638 295.047 33.5387 295.308 34.321C295.592 35.0795 296.019 35.6721 296.588 36.0987C297.157 36.5254 297.892 36.7387 298.792 36.7387ZM319.256 41.2188C317.502 41.2188 316.21 40.8158 315.38 40.0099C314.574 39.1802 314.171 37.8765 314.171 36.0987V26.8543H310.864V22.0187H314.171V16.9343L320.18 16.401V22.0187H323.842V26.8543H320.18V34.961C320.18 35.5062 320.31 35.8854 320.571 36.0987C320.856 36.2884 321.223 36.3832 321.673 36.3832H323.878V41.2188H319.256ZM333.585 41.5743C332.424 41.5743 331.357 41.3491 330.385 40.8987C329.437 40.4484 328.619 39.7965 327.932 38.9432C327.244 38.0899 326.711 37.0469 326.332 35.8143C325.976 34.5817 325.798 33.1832 325.798 31.6187C325.798 29.5091 326.118 27.7195 326.758 26.2499C327.422 24.7565 328.335 23.6187 329.496 22.8365C330.658 22.0543 332.021 21.6632 333.585 21.6632C334.486 21.6632 335.315 21.8054 336.074 22.0899C336.856 22.3506 337.52 22.7417 338.065 23.2632C338.61 23.761 339.013 24.3536 339.274 25.041H339.594L339.807 22.0187H345.532V41.2188H339.807L339.594 38.1965H339.274C338.895 39.2158 338.184 40.0336 337.141 40.6499C336.121 41.2662 334.936 41.5743 333.585 41.5743ZM335.789 36.7387C336.643 36.7387 337.342 36.561 337.887 36.2054C338.432 35.8262 338.835 35.3165 339.096 34.6765C339.381 34.0365 339.523 33.3136 339.523 32.5076V30.7299C339.523 29.8765 339.369 29.1299 339.061 28.4899C338.776 27.8499 338.361 27.3639 337.816 27.0321C337.295 26.6765 336.667 26.4987 335.932 26.4987C335.007 26.4987 334.249 26.7121 333.656 27.1387C333.064 27.5417 332.625 28.1343 332.341 28.9165C332.056 29.675 331.914 30.5758 331.914 31.6187C331.914 32.638 332.044 33.5387 332.305 34.321C332.589 35.0795 333.016 35.6721 333.585 36.0987C334.154 36.5254 334.889 36.7387 335.789 36.7387ZM349.497 41.2188V15.2987H355.862V36.5254L355.008 35.5654H367.026V41.2188H349.497ZM368.341 47.1565V42.2499H370.687C371.185 42.2499 371.612 42.1788 371.967 42.0365C372.323 41.918 372.619 41.7165 372.856 41.4321C373.117 41.1713 373.33 40.8276 373.496 40.401L374.278 38.3387V40.8632L366.492 22.0187H373.105L375.95 31.5476L376.661 34.1432H376.874L377.514 31.5476L380.181 22.0187H386.652L379.434 41.7165C378.912 43.1625 378.272 44.2765 377.514 45.0588C376.779 45.8647 375.938 46.4099 374.99 46.6943C374.041 47.0025 372.987 47.1565 371.825 47.1565H368.341ZM396.484 41.2188C395.086 41.2188 393.995 41.0173 393.213 40.6143C392.455 40.1876 391.921 39.595 391.613 38.8365C391.329 38.078 391.186 37.1891 391.186 36.1699V26.8543H387.88V22.0187H391.186V16.9343L397.195 16.401V22.0187H409.889V41.2188H403.88V26.8543H397.195V35.0676C397.195 35.5891 397.326 35.9447 397.586 36.1343C397.847 36.3002 398.203 36.3832 398.653 36.3832H400.858V41.2188H396.484ZM406.902 20.0987C406.001 20.0987 405.255 19.8617 404.662 19.3876C404.069 18.9136 403.773 18.2499 403.773 17.3965C403.773 16.5432 404.069 15.8913 404.662 15.441C405.255 14.9669 406.001 14.7299 406.902 14.7299C407.826 14.7299 408.573 14.9669 409.142 15.441C409.735 15.8913 410.031 16.5432 410.031 17.3965C410.031 18.2499 409.735 18.9136 409.142 19.3876C408.573 19.8617 407.826 20.0987 406.902 20.0987ZM422.343 41.5743C420.874 41.5743 419.546 41.3373 418.361 40.8632C417.176 40.3891 416.157 39.7136 415.303 38.8365C414.45 37.9595 413.798 36.9165 413.348 35.7076C412.897 34.475 412.672 33.1002 412.672 31.5832C412.672 30.0899 412.897 28.7387 413.348 27.5299C413.822 26.2973 414.486 25.2425 415.339 24.3654C416.216 23.4884 417.259 22.8247 418.468 22.3743C419.677 21.9002 421.016 21.6632 422.486 21.6632C424.192 21.6632 425.697 21.9832 427.001 22.6232C428.305 23.2395 429.336 24.1047 430.095 25.2187C430.877 26.3328 431.292 27.6365 431.339 29.1299H425.472C425.377 28.5373 425.176 28.0513 424.868 27.6721C424.583 27.2928 424.228 27.0084 423.801 26.8187C423.375 26.6291 422.9 26.5343 422.379 26.5343C421.763 26.5343 421.229 26.6528 420.779 26.8899C420.329 27.1269 419.949 27.4706 419.641 27.921C419.357 28.3713 419.132 28.9047 418.966 29.521C418.823 30.1373 418.752 30.8365 418.752 31.6187C418.752 32.7802 418.906 33.7402 419.215 34.4987C419.523 35.2336 419.937 35.7906 420.459 36.1699C421.004 36.5254 421.632 36.7032 422.343 36.7032C422.983 36.7032 423.529 36.5847 423.979 36.3476C424.429 36.1106 424.785 35.8025 425.046 35.4232C425.33 35.0202 425.508 34.558 425.579 34.0365H431.375C431.327 35.5536 430.9 36.881 430.095 38.0187C429.312 39.1328 428.246 40.0099 426.895 40.6499C425.567 41.2662 424.05 41.5743 422.343 41.5743ZM440.87 41.5743C439.708 41.5743 438.642 41.3491 437.67 40.8987C436.722 40.4484 435.904 39.7965 435.216 38.9432C434.529 38.0899 433.996 37.0469 433.616 35.8143C433.261 34.5817 433.083 33.1832 433.083 31.6187C433.083 29.5091 433.403 27.7195 434.043 26.2499C434.707 24.7565 435.619 23.6187 436.781 22.8365C437.942 22.0543 439.305 21.6632 440.87 21.6632C441.771 21.6632 442.6 21.8054 443.359 22.0899C444.141 22.3506 444.805 22.7417 445.35 23.2632C445.895 23.761 446.298 24.3536 446.559 25.041H446.879L447.092 22.0187H452.816V41.2188H447.092L446.879 38.1965H446.559C446.179 39.2158 445.468 40.0336 444.425 40.6499C443.406 41.2662 442.221 41.5743 440.87 41.5743ZM443.074 36.7387C443.928 36.7387 444.627 36.561 445.172 36.2054C445.717 35.8262 446.12 35.3165 446.381 34.6765C446.665 34.0365 446.808 33.3136 446.808 32.5076V30.7299C446.808 29.8765 446.653 29.1299 446.345 28.4899C446.061 27.8499 445.646 27.3639 445.101 27.0321C444.579 26.6765 443.951 26.4987 443.216 26.4987C442.292 26.4987 441.533 26.7121 440.941 27.1387C440.348 27.5417 439.91 28.1343 439.625 28.9165C439.341 29.675 439.199 30.5758 439.199 31.6187C439.199 32.638 439.329 33.5387 439.59 34.321C439.874 35.0795 440.301 35.6721 440.87 36.0987C441.439 36.5254 442.173 36.7387 443.074 36.7387Z",
    fill: "#2B8DC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7967 29.0976C77.8493 24.9088 73.8347 22.9029 69.2459 21.3491C69.2592 21.1727 69.2685 20.9961 69.2737 20.8192C69.51 17.0891 67.4453 13.5146 63.8998 11.7011C61.8525 10.6543 59.0782 10.1703 56.8772 10.0933C56.462 9.49944 56.0703 8.87612 55.6273 8.3044C52.8261 4.69061 48.2182 2.56837 43.3533 2.82392C37.4868 3.1319 32.4264 6.81039 30.6171 12.0812C27.4893 10.1744 23.4591 9.98925 20.1115 11.7011C16.2828 13.6587 14.173 17.6755 14.8409 21.7333C8.34995 22.5884 3.39725 27.6397 3.00118 33.809C2.51911 41.3028 8.25615 47.1436 16.1794 47.1436C18.4786 47.1502 54.4968 47.1551 56.5857 47.1617V50.0825C52.5998 50.0825 20.1393 49.9588 16.1707 49.9474C11.7392 49.9342 7.51871 48.3854 4.43001 45.3556C1.22231 42.2087 -0.244742 37.9666 0.0332066 33.6394C0.459684 27.0073 5.21695 21.4367 11.7687 19.5176C12.0345 15.2568 14.6073 11.3268 18.694 9.23651C21.9208 7.58688 25.7052 7.29775 29.1171 8.3347C31.9452 3.53488 37.2219 0.338005 43.1882 0.024297C48.9539 -0.277944 54.6223 2.25711 58.0272 6.65067C58.2183 6.8964 58.3981 7.14703 58.5736 7.40095C60.8953 7.63848 63.3456 8.22822 65.3173 9.23651C69.3197 11.2834 71.9307 15.1986 72.2347 19.4292C76.6654 21.1574 80.4759 23.5729 82.5197 27.9722C83.3258 29.7078 83.7983 31.568 83.9155 33.4592C84.177 37.6734 82.9479 41.6886 79.8627 44.8117C73.661 51.0892 64.6276 50.0825 56.4047 50.0825C56.4047 50.0825 56.4047 47.8489 56.4047 47.1617L63.9189 47.2829C73.1719 47.3099 81.5729 43.6945 80.9476 33.623C80.8511 32.0676 80.4629 30.5343 79.7967 29.0976Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.163 34.1601L44.6483 33.6855V34.6346H43.6777L44.163 34.1601Z",
    fill: "#111111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5898 33.8428H47.5604V34.6337H46.5898L46.5898 33.8428Z",
    fill: "#111111"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0527 33.8428L48.538 34.2382L49.0233 34.6337H48.0527L48.0527 33.8428Z",
    fill: "#111111"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.6777,
    y: 37.7949,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6777,
    y: 39.1406,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6777,
    y: 35.0283,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6777,
    y: 40.4854,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6777,
    y: 36.3721,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6777,
    y: 41.8291,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6777,
    y: 43.1719,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6777,
    y: 44.5186,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6777,
    y: 45.8633,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6035,
    y: 37.7939,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6035,
    y: 39.1406,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6035,
    y: 35.0273,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6035,
    y: 40.4844,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6035,
    y: 36.3711,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6035,
    y: 41.8301,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6035,
    y: 43.1729,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6035,
    y: 44.5186,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 46.6035,
    y: 45.8623,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 48.0391,
    y: 37.7949,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 48.0391,
    y: 39.1416,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 48.0391,
    y: 35.0283,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 48.0391,
    y: 40.4854,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 48.0391,
    y: 36.3721,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 48.0391,
    y: 41.8311,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 48.0391,
    y: 43.1729,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 48.0391,
    y: 44.5195,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 48.0391,
    y: 45.8633,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5039,
    y: 37.7949,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9531,
    y: 37.7949,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5039,
    y: 39.1406,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9531,
    y: 39.1416,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5039,
    y: 35.0283,
    width: 0.649035,
    height: 0.949057,
    fill: "#111111"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5039,
    y: 40.4854,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9531,
    y: 40.4854,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5039,
    y: 36.3721,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5039,
    y: 41.8291,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9531,
    y: 41.8311,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5039,
    y: 43.1729,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9531,
    y: 43.1738,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5039,
    y: 44.5195,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9531,
    y: 44.5195,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 49.5039,
    y: 45.8633,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 50.9531,
    y: 45.8643,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 45.1367,
    y: 37.7939,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 45.1367,
    y: 39.1416,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 45.1367,
    y: 35.0254,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1367 34.1562H46.1072V34.6308H45.1367V34.1562Z",
    fill: "#111111"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 45.1367,
    y: 40.4824,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 45.1367,
    y: 36.3691,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 45.1367,
    y: 41.8281,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 45.1367,
    y: 43.1719,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 45.1367,
    y: 44.5176,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 45.1367,
    y: 45.8604,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3477,
    y: 38.041,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3477,
    y: 39.3555,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5957 35.3262H55.3068V36.2566H54.5957L54.5957 35.3262Z",
    fill: "#111111"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3477,
    y: 40.6758,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3477,
    y: 36.6445,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3477,
    y: 41.9951,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3477,
    y: 43.3096,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3477,
    y: 44.6328,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 54.3477,
    y: 45.9492,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1953,
    y: 38.0439,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1953,
    y: 39.3613,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1953,
    y: 35.3281,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1953,
    y: 34.0098,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1953,
    y: 32.7451,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6568 31.9308L58.1468 31.4795V32.4099H57.1953L57.6568 31.9308Z",
    fill: "#111111"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1953,
    y: 40.6787,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1953,
    y: 36.6465,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1953,
    y: 41.9961,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1953,
    y: 43.3135,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1953,
    y: 44.6309,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 57.1953,
    y: 45.9512,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6191,
    y: 38.0391,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6191,
    y: 39.3574,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6191,
    y: 35.3242,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6191,
    y: 34.0078,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6191,
    y: 32.7412,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6191,
    y: 31.4756,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6191,
    y: 30.5264,
    width: 0.951487,
    height: 0.632705,
    fill: "#111111"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0469,
    y: 35.3242,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0469,
    y: 34.0068,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0469,
    y: 32.7412,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0469,
    y: 31.4746,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0469,
    y: 30.5264,
    width: 0.951487,
    height: 0.632705,
    fill: "#111111"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4551,
    y: 35.3242,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4551,
    y: 34.0068,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4551,
    y: 32.7412,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4551,
    y: 31.4746,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4531,
    y: 30.5264,
    width: 0.951487,
    height: 0.632705,
    fill: "#111111"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6191,
    y: 40.6748,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6191,
    y: 36.6426,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6191,
    y: 41.9951,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6191,
    y: 43.3125,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6191,
    y: 44.6299,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6191,
    y: 45.9482,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0469,
    y: 38.04,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4746,
    y: 38.0391,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0469,
    y: 39.3613,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4746,
    y: 39.3613,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0469,
    y: 40.6777,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4746,
    y: 40.6777,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0469,
    y: 36.6465,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 61.457,
    y: 36.6465,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0469,
    y: 41.9961,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4746,
    y: 41.998,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0469,
    y: 43.3154,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4746,
    y: 43.3145,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0469,
    y: 44.6309,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4746,
    y: 44.6309,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 60.0469,
    y: 45.9512,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 61.4746,
    y: 45.9521,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7676,
    y: 38.042,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7676,
    y: 39.3604,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7676,
    y: 35.3281,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7676,
    y: 34.0088,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2528 33.2177L56.7191 32.7432V33.6736H55.7676L56.2528 33.2177Z",
    fill: "#111111"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7676,
    y: 40.6777,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7676,
    y: 36.6445,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7676,
    y: 41.9951,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7676,
    y: 43.3154,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7676,
    y: 44.6309,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 55.7676,
    y: 45.9492,
    width: 0.951487,
    height: 0.930448,
    fill: "#111111"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8418,
    y: 37.7959,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M34.291 37.9521L34.7763 38.3476L35.2615 38.743H34.291V37.9521Z",
    fill: "#111111"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8418,
    y: 39.1426,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 34.291,
    y: 39.1436,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8418,
    y: 40.4863,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 34.291,
    y: 40.4863,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7559 40.4863L36.2411 40.9609L36.7264 41.4354H35.7559V40.4863Z",
    fill: "#111111"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6328 40.4863L39.1476 40.9609L38.6623 41.4354H39.6328V40.4863Z",
    fill: "#111111"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8418,
    y: 41.8271,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 34.291,
    y: 41.832,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7559,
    y: 41.832,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    width: 0.970517,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 39.6328 41.8311)",
    fill: "#111111"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 37.207,
    y: 41.8311,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8418,
    y: 43.1738,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 34.291,
    y: 43.1738,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7559,
    y: 43.1738,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    width: 0.970517,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 39.6328 43.1738)",
    fill: "#111111"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 37.207,
    y: 43.1738,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8418,
    y: 44.5186,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 34.291,
    y: 44.5205,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7559,
    y: 44.5205,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    width: 0.970517,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 39.6328 44.5205)",
    fill: "#111111"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 37.207,
    y: 44.5186,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 32.8418,
    y: 45.8652,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 34.291,
    y: 45.8643,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    width: 0.970517,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 41.0918 39.1445)",
    fill: "#111111"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    width: 0.970517,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 41.0918 37.7959)",
    fill: "#111111"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    width: 0.970517,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 41.0918 40.4863)",
    fill: "#111111"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    width: 0.970517,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 41.0918 41.832)",
    fill: "#111111"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    width: 0.970517,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 41.0918 43.1738)",
    fill: "#111111"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    width: 0.970517,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 41.0918 44.5205)",
    fill: "#111111"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    width: 0.970517,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 41.0918 45.8643)",
    fill: "#111111"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 35.7559,
    y: 45.8643,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    width: 0.970517,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 39.6328 45.8643)",
    fill: "#111111"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 37.207,
    y: 45.8643,
    width: 0.970517,
    height: 0.949057,
    fill: "#111111"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1699,
    y: 37.7959,
    width: 0.951487,
    height: 0.949057,
    fill: "#111111"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5977 37.9531L24.0734 38.3486L24.5491 38.744H23.5977V37.9531Z",
    fill: "#111111"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5704 42.3066L25.9795 41.832V42.7811H25.166L25.5704 42.3066Z",
    fill: "#111111"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5645 40.4863H26.0512V41.4354H25.5645V40.4863Z",
    fill: "#111111"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    width: 0.951487,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 28.832 41.8301)",
    fill: "#111111"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    width: 0.951487,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 28.832 40.4873)",
    fill: "#111111"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    width: 0.951487,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 28.832 39.2188)",
    fill: "#111111"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.832 37.9316L27.8805 37.9316V38.7451H28.832V37.9316Z",
    fill: "#111111"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4473,
    y: 41.832,
    width: 0.951487,
    height: 0.949057,
    fill: "#111111"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4473,
    y: 40.4863,
    width: 0.951487,
    height: 0.949057,
    fill: "#111111"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4473 39.2187L27.3988 39.2188V40.1678H26.4473L26.4473 39.2187Z",
    fill: "#111111"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5977 43.8056L24.5491 43.4102V44.1219H23.5977V43.8056Z",
    fill: "#111111"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.127 43.8085L22.1755 43.4131V44.1249H23.127V43.8085Z",
    fill: "#111111"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0215,
    y: 43.1738,
    width: 0.951487,
    height: 0.949057,
    fill: "#111111"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    width: 0.951487,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 28.832 43.1738)",
    fill: "#111111"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4473,
    y: 43.1738,
    width: 0.951487,
    height: 0.949057,
    fill: "#111111"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1699,
    y: 44.5186,
    width: 0.951487,
    height: 0.949057,
    fill: "#111111"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5977,
    y: 44.5186,
    width: 0.951487,
    height: 0.949057,
    fill: "#111111"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0215,
    y: 44.5186,
    width: 0.951487,
    height: 0.949057,
    fill: "#111111"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    width: 0.951487,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 28.832 44.5186)",
    fill: "#111111"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4473,
    y: 44.5205,
    width: 0.951487,
    height: 0.949057,
    fill: "#111111"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 22.1699,
    y: 45.8652,
    width: 0.951487,
    height: 0.949057,
    fill: "#111111"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 23.5977,
    y: 45.8643,
    width: 0.951487,
    height: 0.949057,
    fill: "#111111"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    width: 0.951487,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 30.2598 39.1426)",
    fill: "#111111"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    width: 0.951487,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 30.2598 37.7959)",
    fill: "#111111"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    width: 0.951487,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 30.2598 40.4863)",
    fill: "#111111"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    width: 0.951487,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 30.2598 41.8301)",
    fill: "#111111"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    width: 0.951487,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 30.2598 43.1738)",
    fill: "#111111"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    width: 0.951487,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 30.2598 44.5186)",
    fill: "#111111"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    width: 0.951487,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 30.2598 45.8652)",
    fill: "#111111"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 25.0215,
    y: 45.8643,
    width: 0.951487,
    height: 0.949057,
    fill: "#111111"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    width: 0.951487,
    height: 0.949057,
    transform: "matrix(-1 0 0 1 28.832 45.8652)",
    fill: "#111111"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 26.4473,
    y: 45.8643,
    width: 0.951487,
    height: 0.949057,
    fill: "#111111"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2917 39.4531C23.7209 39.4531 24.1194 39.5796 24.4516 39.7962C25.7719 38.5596 27.0925 37.3233 28.4133 36.0872C28.2217 35.7781 28.1118 35.416 28.1118 35.0285C28.1118 33.8971 29.0495 32.9799 30.2062 32.9799C31.3638 32.9799 32.3014 33.8971 32.3014 35.0285C32.3014 35.2373 32.2691 35.4389 32.2101 35.6286C33.5024 36.3492 34.7949 37.0695 36.0877 37.7895C36.4709 37.3784 37.0222 37.1206 37.6357 37.1206C38.0722 37.1206 38.4772 37.2511 38.8126 37.4748C40.4945 35.9309 42.1764 34.387 43.8583 32.8431C43.6732 32.538 43.5673 32.1822 43.5673 31.8019C43.5673 30.6704 44.505 29.7533 45.6617 29.7533C46.8193 29.7533 47.7569 30.6704 47.7569 31.8019C47.7564 31.9906 47.7313 32.1719 47.6818 32.3458C48.7428 32.9367 49.8037 33.5279 50.8642 34.1193C51.2474 33.7081 51.7986 33.4504 52.4122 33.4504C52.8487 33.4504 53.2537 33.5808 53.5891 33.8038C55.271 32.2604 56.9529 30.7168 58.6348 29.1729C58.4497 28.8677 58.3438 28.5119 58.3438 28.1316C58.3438 27.0002 59.2815 26.083 60.4382 26.083C61.5957 26.083 62.5334 27.0002 62.5334 28.1316C62.5334 29.263 61.5957 30.1802 60.4382 30.1802C60.0025 30.1802 59.5975 30.0498 59.2621 29.8268C57.5802 31.3707 55.8983 32.9143 54.2164 34.4577C54.4007 34.7629 54.5074 35.1187 54.5074 35.499C54.5074 36.6304 53.5689 37.5476 52.4122 37.5476C51.2554 37.5476 50.3178 36.6304 50.3178 35.499C50.3178 35.2902 50.3501 35.0878 50.4091 34.8981C49.3561 34.3114 48.3031 33.7245 47.2501 33.1373C46.8661 33.5745 46.2971 33.8504 45.6617 33.8504C45.226 33.8504 44.821 33.72 44.4856 33.497C42.8037 35.0409 41.1218 36.5848 39.4399 38.1287C39.625 38.4331 39.7309 38.7889 39.7309 39.1692C39.7309 40.3007 38.7924 41.2186 37.6357 41.2186C36.479 41.2186 35.5413 40.3007 35.5413 39.1692C35.5413 38.9605 35.5736 38.7589 35.6326 38.5683C34.3404 37.8483 33.0481 37.128 31.7558 36.4074C31.3727 36.8194 30.8206 37.0771 30.2062 37.0771C29.7778 37.0771 29.3793 36.9514 29.0471 36.7348L25.0854 40.4438C25.2762 40.7529 25.3861 41.115 25.3861 41.5024C25.3861 42.6339 24.4484 43.5511 23.2917 43.5511C22.1349 43.5511 21.1973 42.6339 21.1973 41.5024C21.1973 40.371 22.1349 39.4531 23.2917 39.4531ZM52.4122 34.2537C51.7089 34.2537 51.139 34.8111 51.139 35.499C51.139 36.1869 51.7089 36.7443 52.4122 36.7443C53.1154 36.7443 53.6853 36.1869 53.6853 35.499C53.6853 34.8111 53.1154 34.2537 52.4122 34.2537ZM60.4382 26.8863C59.7357 26.8863 59.1651 27.4437 59.1651 28.1316C59.1651 28.8195 59.7357 29.3769 60.4382 29.3769C61.1414 29.3769 61.7121 28.8195 61.7121 28.1316C61.7121 27.4437 61.1414 26.8863 60.4382 26.8863ZM30.2062 33.7832C29.5038 33.7832 28.9331 34.3407 28.9331 35.0285C28.9331 35.7164 29.5038 36.2738 30.2062 36.2738C30.9095 36.2738 31.4794 35.7164 31.4794 35.0285C31.4794 34.3407 30.9095 33.7832 30.2062 33.7832ZM37.6357 37.9239C36.9332 37.9239 36.3626 38.4813 36.3626 39.1692C36.3626 39.8571 36.9332 40.4145 37.6357 40.4145C38.3389 40.4145 38.9088 39.8571 38.9088 39.1692C38.9088 38.4813 38.3389 37.9239 37.6357 37.9239ZM45.6617 30.5566C44.9593 30.5566 44.3886 31.114 44.3886 31.8019C44.3886 32.4897 44.9593 33.0471 45.6617 33.0471C46.365 33.0471 46.9357 32.4897 46.9357 31.8019C46.9357 31.114 46.365 30.5566 45.6617 30.5566ZM23.2917 40.2572C22.5884 40.2572 22.0185 40.8146 22.0185 41.5024C22.0185 42.1903 22.5884 42.7477 23.2917 42.7477C23.9949 42.7477 24.5648 42.1903 24.5648 41.5024C24.5648 40.8146 23.9949 40.2572 23.2917 40.2572Z",
    fill: "#2B8DC8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2263 32.5423V23.0718C30.2263 22.4084 29.6811 21.8652 29.0143 21.8652H23.3507C22.6839 21.8652 22.1387 22.4084 22.1387 23.0718V39.2851C22.4804 39.1103 22.8691 39.0115 23.28 39.0115C23.6527 39.0115 24.0183 39.0937 24.3513 39.2511L27.7728 35.9927C27.6441 35.6883 27.5773 35.3602 27.5773 35.0266C27.5773 33.6524 28.6972 32.5376 30.0785 32.5376C30.1283 32.5376 30.1776 32.5391 30.2263 32.5423Z",
    fill: "#2B8DC8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8535 35.4824L35.9648 37.2464C36.4098 36.8827 36.9685 36.6811 37.5526 36.6811C37.934 36.6811 38.3067 36.7665 38.6461 36.9309L40.9412 34.7882V15.0249C40.9412 14.3615 40.3952 13.8184 39.7284 13.8184H34.0662C33.3995 13.8184 32.8535 14.3615 32.8535 15.0249V35.4824Z",
    fill: "#2B8DC8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 9.27002V30.3696C44.2022 29.7307 44.9501 29.3133 45.795 29.3133C47.1771 29.3133 48.2969 30.4281 48.2969 31.8022C48.2969 31.9093 48.2903 32.0155 48.277 32.1209L50.8442 33.5765C51.1351 33.3385 51.4744 33.1701 51.8376 33.0815V9.27002C51.8376 8.60666 51.2924 8.06348 50.6256 8.06348H44.962C44.2952 8.06348 43.75 8.60666 43.75 9.27002Z",
    fill: "#2B8DC8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3164 32.5399L58.0292 29.0737C57.9068 28.7748 57.8433 28.4554 57.8433 28.1296C57.8433 26.7555 58.963 25.6406 60.3442 25.6406C61.1985 25.6406 61.9527 26.0668 62.404 26.7167V23.0718C62.404 22.4084 61.8581 21.8652 61.1913 21.8652H55.5291C54.8624 21.8652 54.3164 22.4084 54.3164 23.0718V32.5399Z",
    fill: "#2B8DC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginlogo);
export default __webpack_public_path__ + "static/media/loginlogo.020f03750a6f98109b387f9a67e27e46.svg";
export { ForwardRef as ReactComponent };